const { Component } = require('react')
const PropTypes = require('prop-types')

class Item extends Component {
  static get propTypes () {
    return {
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      thumbnail: PropTypes.string
    }
  }

  get className () {
    return 'item'
  }

  renderBody () {
    // ...
  }

  renderExtras () {
    // ...
  }

  render () {
    return (
      <div className={this.className}>
        {this.renderBody()}
        {this.renderExtras()}
      </div>
    )
  }
}

module.exports = Item
